<template>
  <TableComp
    v-if="permissions"
    :name="$t('global.team')"
    :headers="headers"
    :status="status"
    :number-of-items="permissions.length"
    empty-image="permissions"
    v-on:update:list="updateList"
    :header-actions="tableActions"
  >
    <template #desktop>
      <tr v-for="(permission, index) in permissions" v-bind:key="index">
        <td>
          {{ getRoleName(permission) }}
        </td>

        <td class="text-center text-secondary">
          {{ getActionList(permission) }}
        </td>

        <!-- <td class="text-end actions">
          <div class="d-flex justify-content-center">
            <ThreeDotsMenu :items="menuItems(permission)" />
          </div>
        </td> -->
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="(permission, index) in permissions" v-bind:key="index">
        <template #header>
          <div class="d-flex align-items-center">
            <div class="flex-fill">
              <div class="d-flex align-items-center">
                {{ getRoleName(permission) }}
              </div>
            </div>

            <!-- <div>
              <div class="d-flex justify-content-end mr-4">
                <ThreeDotsMenu :items="menuItems(permission)" />
              </div>
            </div> -->
          </div>
        </template>
        <template #content>
          <div class="row">
            <div class="col">{{ $t("global.name") }}:</div>
            <div class="col">
              {{ getRoleName(permission) }}
            </div>
          </div>

          <div class="row">
            <div class="col">{{ $t("global.permissions") }}:</div>
            <div class="col">{{ getActionList(permission) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { computed } from "@vue/composition-api";
import NavLink from "@/classes/NavLink";
import Status from "@/classes/Status";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TeamDeleteModal from "@/components/smart/modals/TeamDelete";
import TeamEditModal from "@/components/smart/modals/TeamEdit";

export default {
  name: "PermissionTable",
  props: {
    team: Object,
    permissions: Array,
    status: Status,
  },
  components: {
    TableComp,
    TableMobileRow,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.name")),
      new TableHeader(root.$t("global.permissions"), "justify-content-center"),
    ];

    const deleteTeam = () => {
      store.dispatch("modals/open", {
        template: TeamDeleteModal,
        data: { team: props.team },
      });
    };

    const editTeam = () => {
      store.dispatch("modals/open", {
        template: TeamEditModal,
        data: { team: props.team },
      });
    };

    const tableActions = computed(() => {
      const actionsforTables = [
        new NavLink(root.$t("global.team-edit"), "edit", editTeam, false, null, "epsilon"),
      ];
      if (!props.team?.isUsed) {
        actionsforTables.push(
          new NavLink(root.$t("global.team-delete"), "trash", deleteTeam, false, null, "epsilon")
        );
      }
      return actionsforTables;
    });

    const getActionList = (permission) =>
      permission.actions.length
        ? permission.actions.map((action) => root.$t(`global.permission-name-${action}`)).join(", ")
        : root.$t("global.none");

    const getRoleName = (permission) => root.$t(`global.role-name-${permission.name}`);

    const updateList = () => {
      store.dispatch("team/getList", { forceUpdate: true });
    };

    return {
      getRoleName,
      getActionList,
      headers,
      updateList,
      tableActions,
    };
  },
};
</script>
